module.exports = "<div ui-view class=\"col-md-6\">\n</div>\n"